export const SET_USERS = 'SET_USERS';
export const CLEAR_USERS = 'CLEAR_USERS';

export const clearUsers = {
  type: CLEAR_USERS,
}

export const setUsers = (data, agencies) => {
  return {
    type: SET_USERS,
    payload: data,
    agencies
  }
}